/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */
/**
 * @deprecated Use `import SectionMessage from '@atlaskit/section-message/src/section-message'` instead.
 */
export { default } from './section-message';
/**
 * @deprecated Use `import { SectionMessageAction } from '@atlaskit/section-message/src/section-message-action'` instead.
 */
export { default as SectionMessageAction } from './section-message-action';
/**
 * @deprecated Use `import type { Appearance, SectionMessageProps, SectionMessageActionProps } from '@atlaskit/section-message/types'` instead.
 */
export type { Appearance, SectionMessageProps, SectionMessageActionProps } from './types';
